"use client";

import { useEffect, useRef } from "react";

interface Props {
  hasMore: boolean;
  onIntersect(): void;
}

export const InfiniteScroll = ({ hasMore, onIntersect }: Props) => {
  const observerTarget = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const current = observerTarget.current;
    if (!current) return;

    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting && hasMore) {
        onIntersect();
      }
    });

    observer.observe(current);

    return () => observer.disconnect();
  }, [hasMore, onIntersect]);

  return <div ref={observerTarget} aria-hidden="true" />;
};
